import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '@shared/providers/utils.service';

@Component({
  selector: 'app-survey-signature-form',
  templateUrl: './survey-signature-form.component.html',
  styleUrls: ['./survey-signature-form.component.scss'],
})
export class SurveySignatureFormComponent implements OnDestroy {
  @Input() responsibleSignature = '';
  @Input() surveyorSignature = '';
  public subscriptions = [];
  @Output() submitEvent = new EventEmitter();
  @Output() showModalEvent = new EventEmitter();
  constructor(private utils: UtilsService, private translate: TranslateService) {}

  async showModal(isSurveyor: boolean) {
    this.showModalEvent.emit(isSurveyor);
  }

  submit() {
    if (this.surveyorSignature !== '') {
      const signatures: any = {};
      signatures.survey = this.surveyorSignature;
      if (this.responsibleSignature) {
        signatures.responsible = this.responsibleSignature;
      }
      this.submitEvent.emit(signatures);
    } else {
      this.utils.showToast('', `${this.translate.instant('COMPONENTS.FORMS.THE_SURVEYORS')}`);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
